/* Fly-to-cart animation: clone the product image and animate it into the
   header cart icon on add-to-cart. Standalone (does not touch theme.js).
   Cosmetic only — runs in parallel with the theme's own add-to-cart logic. */
(function () {
  function getCartTarget() {
    return document.querySelector('.header-items__cart-link');
  }

  function getSourceImage(btn) {
    var pdp = btn.closest('[data-section-type="product"]');
    if (pdp) {
      var main = pdp.querySelector('.media-gallery__main img, .product-media__image, .media-gallery img');
      if (main) return main;
    }
    var card = btn.closest('.card, [data-handle]');
    if (card) {
      var cardImg = card.querySelector('.card__image img, img');
      if (cardImg) return cardImg;
    }
    return null;
  }

  function pulseCart() {
    // Re-query instead of reusing the node captured at click time: the
    // theme swaps in a fresh header-items markup after add-to-cart completes.
    var cart = getCartTarget();
    if (!cart) return;
    var icon = cart.querySelector('.cart-link-icon') || cart;
    icon.classList.remove('cart-bump');
    void icon.offsetWidth; // force reflow to restart the animation
    icon.classList.add('cart-bump');

    var count = cart.querySelector('.cart-count');
    if (count) {
      count.classList.remove('cart-count--pop');
      void count.offsetWidth;
      count.classList.add('cart-count--pop');
    }
  }

  function flyToCart(btn) {
    var cart = getCartTarget();
    var img = getSourceImage(btn);
    if (!cart || !img) return;

    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
    if (!src) return;

    var imgRect = img.getBoundingClientRect();
    if (!imgRect.width || !imgRect.height) return;
    var cartRect = cart.getBoundingClientRect();

    var startSize = Math.min(90, imgRect.width);
    var startX = imgRect.left + imgRect.width / 2 - startSize / 2;
    var startY = imgRect.top + imgRect.height / 2 - startSize / 2;
    var endSize = 26;
    var endX = cartRect.left + cartRect.width / 2 - endSize / 2;
    var endY = cartRect.top + cartRect.height / 2 - endSize / 2;

    var clone = document.createElement('img');
    clone.src = src;
    clone.className = 'cart-fly-image';
    clone.style.left = startX + 'px';
    clone.style.top = startY + 'px';
    clone.style.width = startSize + 'px';
    clone.style.height = startSize + 'px';
    document.body.appendChild(clone);

    var startTime = null;
    var duration = 900;
    var cpX = (startX + endX) / 2;
    var cpY = Math.min(startY, endY) - Math.abs(endX - startX) * 0.4 - 40;

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function step(ts) {
      if (!startTime) startTime = ts;
      var t = Math.min((ts - startTime) / duration, 1);
      var e = easeOut(t);
      var bx = (1 - e) * (1 - e) * startX + 2 * (1 - e) * e * cpX + e * e * endX;
      var by = (1 - e) * (1 - e) * startY + 2 * (1 - e) * e * cpY + e * e * endY;
      var size = startSize + (endSize - startSize) * e;
      clone.style.left = bx + 'px';
      clone.style.top = by + 'px';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.opacity = String(Math.pow(1 - e, 0.5));
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        clone.remove();
        pulseCart();
      }
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], .product-add button[type="submit"]');
    if (!btn || btn.disabled) return;
    flyToCart(btn);
  }, true);
})();
